var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showMoneyInput && (_vm.currentBetSlipState <= 1 || _vm.stake)
    ? _c(
        "div",
        { staticClass: "stake-n-return" },
        [
          _c("div", { staticClass: "stake-line" }, [
            _c(
              "span",
              { staticClass: "stake" },
              [
                _c("money-input", {
                  ref: "wagerInput",
                  attrs: {
                    id: 1,
                    inputType: "wager",
                    placeholder: _vm.placeholder.wager,
                    focus: _vm.focus,
                    currentBetSlipState: _vm.currentBetSlipState,
                    stakeChanged: !!(
                      _vm.stakeChange &&
                      _vm.stakeChange.old &&
                      [5, 6].includes(_vm.currentBetSlipState) &&
                      (_vm.inRefferalStakeChanged || _vm.nonReferalStakeChanged)
                    ),
                    stakeChange: _vm.stakeChange,
                    perType: _vm.perType,
                    minStake: _vm.minStake[_vm.perType],
                    maxStake: _vm.maxStake[_vm.perType],
                    statusToConfirm: _vm.statusToConfirm,
                    disabledByVoucher: _vm.disabledByVoucher
                  },
                  on: {
                    setFocus: _vm.setFocus,
                    dismissError: _vm.dismissError,
                    hasError: _vm.hasError
                  },
                  model: {
                    value: _vm.stake,
                    callback: function($$v) {
                      _vm.stake = $$v
                    },
                    expression: "stake"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "returns" },
              [
                _c("money-input", {
                  attrs: {
                    id: 2,
                    inputType: "winning",
                    placeholder: _vm.placeholder.winning,
                    focus: _vm.focus,
                    currentBetSlipState: _vm.currentBetSlipState,
                    perType: _vm.perType,
                    minStake: _vm.minStake[_vm.perType],
                    maxStake: _vm.maxStake[_vm.perType],
                    statusToConfirm: _vm.statusToConfirm,
                    disabledByVoucher: _vm.disabledByVoucher
                  },
                  on: {
                    setFocus: _vm.setFocus,
                    dismissError: _vm.dismissError,
                    hasError: _vm.hasError
                  },
                  model: {
                    value: _vm.winning,
                    callback: function($$v) {
                      _vm.winning = $$v
                    },
                    expression: "winning"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.applicableVoucher &&
          (_vm.applicableVoucher.MinStake || _vm.applicableVoucher.MaxStake) &&
          (!_vm.discount || _vm.discount <= 0.0001)
            ? _c("div", { staticClass: "voucher voucherData" }, [
                _vm.applicableVoucher.MinStake
                  ? _c("span", { staticClass: "voucherMinStake" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("Betslip.voucher.minStake")) + ": "
                        )
                      ]),
                      _vm._v(
                        _vm._s(_vm.currencySymbol) +
                          _vm._s(_vm.applicableVoucher.MinStake)
                      )
                    ])
                  : _vm._e(),
                _vm.applicableVoucher.MaxStake
                  ? _c("span", { staticClass: "voucherMaxStake" }, [
                      _c("span", [
                        _vm.applicableVoucher.MinStake
                          ? _c("span", [_vm._v("; ")])
                          : _vm._e(),
                        _vm._v(
                          _vm._s(_vm.$t("Betslip.voucher.maxStake")) + ": "
                        )
                      ]),
                      _vm._v(
                        _vm._s(_vm.currencySymbol) +
                          _vm._s(_vm.applicableVoucher.MaxStake)
                      )
                    ])
                  : _vm._e()
              ])
            : _vm.voucher ||
              (_vm.discount &&
                _vm.applicableVoucher &&
                _vm.applicableVoucher.DiscountPercentage)
            ? _c("div", { staticClass: "voucher" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("BetSlip.StakeAdReturn.promotions.discount")
                    ) +
                    ": "
                ),
                _c("span", { staticClass: "discount" }, [
                  _vm._v(
                    _vm._s(_vm.currencySymbol) +
                      _vm._s((_vm.voucher || _vm.discount).toFixed(2))
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasErrors
            ? _c(
                "div",
                { staticClass: "error-msg" },
                [
                  _c("v-icon", [_vm._v("info_outline")]),
                  _vm._v(" "),
                  _vm._l(_vm.errors, function(e) {
                    return _c("div", [
                      e
                        ? _c(
                            "span",
                            {
                              key: e,
                              attrs: {
                                id: _vm.perType + "BetSlipErrorMessageId"
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t("BetSlip.stakeNreturn.error." + e, {
                                      min: _vm.minStake[_vm.perType],
                                      max: _vm.maxStake[_vm.perType],
                                      currency: _vm.currencySymbol
                                    })
                                  )
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("promotion-vouchers", {
            attrs: {
              allowedBetTypesAndReturns: _vm.allowedBetTypesAndReturns,
              tab: _vm.tab,
              currentBetSlipState: _vm.currentBetSlipState,
              isFastBet: _vm.isFastBet
            },
            on: { dismissError: _vm.dismissError }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32869906", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32869906","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/common/stakeNreturn.vue
// module id = null
// module chunks = 